var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M450.03,126.46c-1.65-2.56-3.37-5.07-5.17-7.52-23.92-32.66-63.73-55.02-102.42-65.15-16.95-4.44-34.36-6.77-51.73-7.36-113.96-3.85-155.82,83.48-192.54,105.99C61.46,174.94,5.12,213.39,12.19,294.18c5.36,61.42,42.96,120.16,111.63,146.89,7.56,2.95,15.51,5.52,23.83,7.64,15.48,3.96,32.25,6.44,50.33,7.19,51.92,2.15,94.07-9.48,135.3-38.77,9.58-6.81,19.12-14.49,31.56-15.33,9.04-.61,17.61,2.41,8.16,10.53-11.11,9.54,1.71,28.32,29.9,15.27,47.09-21.78,66.46-68.78,75.59-116.57,11.2-58.66,5.77-131.61-28.46-184.58Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.03,126.46c-1.65-2.56-3.37-5.07-5.17-7.52-23.92-32.66-63.73-55.02-102.42-65.15-16.95-4.44-34.36-6.77-51.73-7.36-113.96-3.85-155.82,83.48-192.54,105.99C61.46,174.94,5.12,213.39,12.19,294.18c5.36,61.42,42.96,120.16,111.63,146.89,7.56,2.95,15.51,5.52,23.83,7.64,15.48,3.96,32.25,6.44,50.33,7.19,51.92,2.15,94.07-9.48,135.3-38.77,9.58-6.81,19.12-14.49,31.56-15.33,9.04-.61,17.61,2.41,8.16,10.53-11.11,9.54,1.71,28.32,29.9,15.27,47.09-21.78,66.46-68.78,75.59-116.57,11.2-58.66,5.77-131.61-28.46-184.58Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-4"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12.16,
    y1: 406,
    x2: 473.19,
    y2: 406,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M385.47,49.2c-2.42,0-4.45,1.57-5.18,3.74H111.61c-.74-2.17-2.77-3.74-5.18-3.74-3.04,0-5.5,2.46-5.5,5.5s2.46,5.5,5.5,5.5c2.42,0,4.45-1.57,5.18-3.74H380.28c.74,2.17,2.77,3.74,5.18,3.74,3.04,0,5.5-2.46,5.5-5.5s-2.46-5.5-5.5-5.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.16,57.45c3.83,93.15,7.18,187.18,11.19,279.99l-.4,18.19s-17.22,0-26.28,.91c-9.06,.91-23.11,.91-33.08,.91s-15.41-3.63-15.41-3.63l.65-16.4c2.01-92.76,4.18-186.8,5.6-279.96",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.23,
    y1: 322.04,
    x2: 132.18,
    y2: 333,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.17,
    y1: 108.35,
    x2: 132.27,
    y2: 312.3,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.4,
    y1: 55.39,
    x2: 133.19,
    y2: 102.27,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.85,
    y1: 162.52,
    x2: 146.79,
    y2: 298.3,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.45,
    y1: 56.6,
    x2: 148.97,
    y2: 154.03,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.27,
    y1: 200.28,
    x2: 163.84,
    y2: 326.31,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.86,
    y1: 110.79,
    x2: 163.22,
    y2: 189.94,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.62,
    y1: 57.82,
    x2: 162.82,
    y2: 101.05,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.16,57.45c-3.68,98.62-8.37,198.24-11.9,296.34,0,0,11.73,1.77,19.27,1.77h38.49c8.3,0,17.82-1.84,17.82-1.84-1.74-98.03-2.91-197.65-5.95-296.27",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.09,
    y1: 322.04,
    x2: 357.13,
    y2: 333,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 356.15,
    y1: 108.35,
    x2: 357.04,
    y2: 312.3,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.92,
    y1: 55.39,
    x2: 356.12,
    y2: 102.27,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340.47,
    y1: 162.52,
    x2: 342.52,
    y2: 298.3,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 338.87,
    y1: 56.6,
    x2: 340.34,
    y2: 154.03,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 326.05,
    y1: 200.28,
    x2: 325.47,
    y2: 326.31,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 326.45,
    y1: 110.79,
    x2: 326.09,
    y2: 189.94,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 326.69,
    y1: 57.82,
    x2: 326.5,
    y2: 101.05,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "176.87 83.92 203.91 83.92 203.91 115.46 178.67 115.46",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.62,
    y: 84,
    width: 28.26,
    height: 31.64,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "312.81 83.92 285.77 83.92 285.77 115.46 311.01 115.46",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.79,
    y: 84,
    width: 28.26,
    height: 31.64,
    transform: "translate(533.85 199.63) rotate(180)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "181.33 227.26 237.61 227.26 237.61 132.69 178.86 132.69",
    style: {
      fill: "none",
      opacity: 0.2,
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "309.96 131.89 252.45 131.89 252.45 227.26 305.63 227.26",
    style: {
      fill: "none",
      opacity: 0.2,
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "183.19 249.7 237.61 249.7 237.61 344.77 187.31 344.77",
    style: {
      fill: "none",
      opacity: 0.2,
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "306.25 248.9 252.45 248.9 252.45 345.65 301.5 345.65",
    style: {
      fill: "none",
      opacity: 0.2,
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 187.06,
    y1: 351.69,
    x2: 302.26,
    y2: 351.69,
    style: {
      fill: "none",
      opacity: 0.2,
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.64,
    y1: 72.97,
    x2: 312.75,
    y2: 72.97,
    style: {
      fill: "none",
      opacity: 0.2,
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.02,
    y1: 73.62,
    x2: 245.02,
    y2: 350.39,
    style: {
      fill: "none",
      opacity: 0.2,
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.37,
    y1: 125.37,
    x2: 310.76,
    y2: 125.37,
    style: {
      fill: "none",
      opacity: 0.2,
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M470.88,325.47c-2.13,.66-7.1,0-7.1,0-.05,0,1.43-3.14,1.54-3.33,1.34-2.16,5.21-5.56,7.98-4.87,1.99,.5,2.9,2.65,2.23,4.5-.68,1.9-2.84,3.12-4.65,3.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.6,324.08s-.54-3.41-.55-3.63c-.07-2.55,1.28-7.51,3.97-8.46,1.94-.69,3.88,.61,4.34,2.52,.48,1.96-.64,4.17-1.85,5.64-1.41,1.73-5.92,3.92-5.92,3.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.47,360.75c1.67,.21,4.96-.72,5.88-1,.15,1.42,.33,2.82,.58,4.2,.12,.59,.2,1.2,.35,1.76,.13,.57,.27,1.13,.4,1.68,.31,1.14,.6,2.2,.92,3.26,.16,.53,.32,1.03,.48,1.55-.4-.82-1.05-2.11-1.12-2.22-1.22-1.87-4.69-4.78-7.11-4.12-1.74,.48-2.49,2.38-1.87,4,.64,1.65,2.56,2.69,4.16,3.15,1.77,.51,5.67-.05,6.15-.12,.4,1.26,.8,2.49,1.19,3.63,.26,.75,.51,1.45,.76,2.14h1.65c-.33-.84-.66-1.7-1-2.64-.38-1.02-.76-2.11-1.15-3.24,.44-.18,3.81-1.62,5.17-2.93,1.42,.91,3.04,1.67,3.33,1.81-.36,1.27-.71,2.51-1.01,3.68-.3,1.18-.57,2.27-.82,3.32h1.6c.2-.94,.42-1.91,.66-2.96,.25-1.06,.53-2.18,.83-3.33,.48,.09,4.35,.81,6.13,.37,1.62-.4,3.58-1.35,4.29-2.98,.69-1.59,.01-3.53-1.71-4.07-2.39-.76-5.97,2-7.27,3.83-.08,.12-.91,1.61-1.32,2.38,.18-.69,.36-1.38,.57-2.1,.28-1.04,.62-2.12,.94-3.18,.18-.54,.37-1.09,.56-1.64,.18-.56,.42-1.07,.63-1.62,.32-.79,.7-1.6,1.07-2.4,1.04,.35,4.1,1.34,5.72,1.2,1.67-.15,3.75-.79,4.69-2.29,.92-1.47,.55-3.48-1.07-4.28-2.25-1.11-6.21,1.08-7.76,2.68-.05,.05-.34,.43-.69,.87,.39-.77,.77-1.54,1.18-2.31,1.18-2.18,2.45-4.37,3.72-6.56,.26-.46,.52-.92,.78-1.38,.87,.3,4.18,1.4,5.87,1.25,1.67-.15,3.75-.79,4.69-2.29,.92-1.47,.55-3.48-1.07-4.28-2.25-1.11-6.2,1.08-7.76,2.68-.06,.06-.41,.5-.79,1.01,.67-1.2,1.32-2.41,1.93-3.63,1.07-2.13,2.01-4.28,2.76-6.44,.31,.11,4.16,1.47,6.04,1.31,1.67-.15,3.75-.79,4.69-2.29,.92-1.47,.55-3.48-1.07-4.28-2.25-1.11-6.21,1.08-7.76,2.68-.11,.11-1.37,1.74-1.8,2.34,0-.03,.02-.05,.03-.08,.76-2.27,1.21-4.54,1.53-6.71,.32-2.16,.44-4.23,.5-6.13,.06-1.9,0-3.65-.06-5.19-.04-.84-.09-1.6-.15-2.31l.04,.03s1.04-2.85,1.09-3.04c.49-2.18,.17-6.69-1.99-7.97-1.55-.92-3.45-.13-4.17,1.44-.74,1.61-.15,3.7,.64,5.18,.81,1.51,3.58,3.72,4.28,4.26,.04,.74,.08,1.53,.11,2.41,.03,1.54,.05,3.28-.05,5.17-.03,.5-.08,1.05-.11,1.57-.12-.9-.3-2.13-.33-2.25-.57-2.17-2.94-6.02-5.44-6.16-1.8-.1-3.12,1.47-3.04,3.2,.08,1.77,1.57,3.36,2.95,4.3,1.44,.99,5.01,1.67,5.79,1.81-.1,1.16-.24,2.36-.45,3.59-.36,2.13-.86,4.39-1.66,6.61l-.14-.02c0-.84-.07-2.61-.09-2.76-.33-2.21-2.26-6.3-4.73-6.72-1.78-.3-3.26,1.12-3.37,2.85-.11,1.77,1.19,3.51,2.46,4.6,1.46,1.26,5.54,2.44,5.7,2.48-.77,2.07-1.72,4.13-2.81,6.17-.78,1.48-1.64,2.95-2.51,4.41,0-.59-.07-2.92-.09-3.08-.33-2.21-2.26-6.3-4.73-6.72-1.78-.3-3.26,1.12-3.37,2.85-.11,1.77,1.2,3.51,2.46,4.6,1.42,1.23,5.33,2.38,5.66,2.47-.4,.66-.79,1.33-1.19,1.99-1.31,2.16-2.63,4.33-3.88,6.5-.43,.75-.83,1.51-1.23,2.27-.01-.89-.07-2.5-.09-2.64-.33-2.22-2.26-6.3-4.73-6.72-1.78-.3-3.26,1.12-3.37,2.85-.11,1.77,1.19,3.51,2.46,4.6,1.27,1.1,4.54,2.13,5.46,2.41-.66,1.27-1.28,2.54-1.83,3.82-.23,.56-.49,1.11-.68,1.66-.2,.55-.4,1.09-.6,1.63-.37,1.12-.71,2.17-1.03,3.22-.16,.53-.3,1.04-.46,1.56,.12-.9,.29-2.33,.29-2.47,.01-2.24-1.28-6.57-3.66-7.36-1.72-.56-3.39,.61-3.77,2.3-.05,.22-.07,.43-.08,.65-1.15,1.64-1.81,4.02-1.86,5.51,0,.14,.13,1.84,.21,2.71-.23-.68-.46-1.35-.69-2.07-.33-1.02-.66-2.11-.97-3.17-.14-.55-.29-1.11-.44-1.68-.16-.57-.24-1.13-.37-1.7-.17-.84-.3-1.72-.43-2.59,1.06-.28,4.16-1.15,5.43-2.16,1.31-1.04,2.69-2.73,2.64-4.5-.04-1.73-1.46-3.21-3.26-2.98-2.49,.31-4.58,4.32-5,6.52-.01,.07-.05,.55-.09,1.11-.1-.86-.21-1.71-.29-2.58-.22-2.47-.36-5-.52-7.53-.03-.53-.07-1.05-.11-1.58,.89-.23,4.26-1.14,5.59-2.2,1.31-1.04,2.69-2.73,2.64-4.5-.04-1.73-1.46-3.21-3.26-2.98-2.49,.31-4.58,4.32-5,6.52-.01,.08-.06,.64-.11,1.28-.1-1.37-.23-2.74-.39-4.09-.28-2.37-.69-4.68-1.26-6.89,.32-.08,4.28-1.07,5.76-2.24,1.31-1.04,2.69-2.73,2.64-4.5-.04-1.73-1.46-3.21-3.26-2.98-2.49,.31-4.58,4.32-5,6.52-.03,.16-.18,2.21-.21,2.94,0-.03-.01-.05-.02-.08-.62-2.32-1.5-4.45-2.43-6.44-.93-1.98-1.97-3.77-2.96-5.39-1-1.62-2.01-3.05-2.91-4.3-.5-.67-.96-1.28-1.4-1.84h.05s-.7-2.95-.77-3.13c-.79-2.09-3.55-5.67-6.06-5.55-1.8,.09-2.95,1.79-2.69,3.5,.27,1.75,1.92,3.17,3.39,3.97,1.51,.82,5.04,1.13,5.92,1.19,.45,.59,.91,1.23,1.42,1.95,.88,1.27,1.85,2.71,2.81,4.35,.26,.44,.51,.91,.77,1.37-.6-.68-1.43-1.61-1.52-1.69-1.67-1.49-5.77-3.4-7.93-2.13-1.56,.91-1.79,2.95-.77,4.35,1.04,1.43,3.16,1.93,4.84,1.96,1.74,.03,5.1-1.37,5.83-1.68,.56,1.03,1.1,2.09,1.61,3.24,.88,1.98,1.71,4.13,2.26,6.43-.07,.03-.06,.03-.13,.06-.47-.7-1.5-2.14-1.6-2.25-1.49-1.67-5.36-4.01-7.65-2.99-1.65,.73-2.1,2.73-1.24,4.24,.88,1.54,2.93,2.27,4.59,2.48,1.91,.24,5.97-1.02,6.12-1.07,.5,2.15,.84,4.39,1.06,6.69,.16,1.67,.26,3.36,.34,5.06-.32-.5-1.66-2.4-1.78-2.52-1.49-1.67-5.36-4.01-7.65-2.99-1.65,.73-2.1,2.73-1.24,4.24,.88,1.54,2.93,2.27,4.59,2.48,1.87,.24,5.76-.96,6.08-1.06,.04,.77,.08,1.54,.11,2.32,.1,2.53,.19,5.06,.36,7.56,.06,.87,.15,1.72,.23,2.57-.5-.73-1.44-2.05-1.53-2.15-1.49-1.67-5.36-4.01-7.65-2.99-1.65,.73-2.1,2.73-1.24,4.24,.88,1.54,2.93,2.27,4.59,2.48Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M439.76,415.22h0c-10.84,0-19.62-8.78-19.62-19.62v-18.86h39.24v18.86c0,10.84-8.78,19.62-19.62,19.62Z",
    style: {
      fill: "#8f8f8f",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M247.33,222.71c-3.04-5.65-15.42-5.57-15.42-5.57,0,0,6.73,6.01,7.59,9.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.09,168.75s-4.89-7.88-12.78-9.79c-7.88-1.9-24.47,5.44-38.87,20.12-14.41,14.68-10.87,21.75-9.24,25.83,1.63,4.08,2.99,9.24,2.99,9.24,0,0-8.43-3.26-13.32,.54s2.45,14.95,3.53,16.04c1.09,1.09-7.34,4.89-8.16,5.71-.82,.82-6.52,6.52-3.26,11.69,3.26,5.17,17.94,13.05,17.94,13.86s-2.72,7.34,1.36,10.06c4.08,2.72,11.15,3.26,13.86,2.72s20.12,2.99,22.02-11.96c1.9-14.95-3.53-39.15-3.53-39.15l38.6-25.28,14.68,18.76s10.16-1.43,13.42-6.33c3.26-4.89,.44-20.59-6.9-26.29s-8.16-.27-8.16-.27c0,0,.27-10.33-9.24-16.04s-14.95,.54-14.95,.54Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.52,205.18c6.25-.27,17.67,8.97,17.67,8.97,0,0-11.69-4.08-16.31-1.36-4.62,2.72-3.81,7.07-3.81,7.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M174.29,252.75s2.72,5.16,.54,10.33c-2.17,5.17-3.81,4.35-13.59,8.7-9.79,4.35-38.6,14.68-43.49,23.65-4.89,8.97-8.43,25.28-7.61,40.78,.82,15.5,10.87,65.79,13.05,67.96,2.17,2.17,5.16,1.9,5.16,1.9h168.27s9.51-1.9,10.06-16.31-3.81-27.73-7.61-35.07c-3.81-7.34-9.79-25.28-16.31-41.32-6.52-16.04-8.16-28.54-16.85-35.07-8.7-6.52-23.92-9.51-23.92-9.51l-19.57-5.17-2.72-2.45-45.4-8.43Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M260.22,398.23s-.4,1.62,2.83,2.23c3.24,.61,6.07,2.63,10.32,1.62s8.09-4.05,8.29-13.75c.2-9.71-2.02-13.75-6.27-15.98-4.25-2.23-12.95,1.21-13.96,2.23s-1.82,3.64-1.62,6.07c.2,2.43,.4,17.6,.4,17.6Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.25,372.54s7.48-4.65,9.3-7.69c1.82-3.03,15.17-5.46,20.83-1.82,5.66,3.64,6.07,7.28,6.88,9.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.05,400.46s7.28,5.26,17.4,5.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,359.77s10.05-3.35,16.76,.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.25,375.13s.56,2.23,.28,5.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.35,367.81c1.32-7.15,1.32-50.31,1.32-50.31,0,0,1.59,28.86,8.74,43.16",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.73,321.4c2.57,10.87,6.01,27.98,5.34,39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.12,311.15s.54,1.94,1.35,5.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.24,271.78c-.42,.19-.89,.39-1.39,.6,2.72,5.21,9.85,16.89,23.68,27.67,18.49,14.41,27.14,17.45,27.14,17.45,3.81-2.17,21.25-37.3,22.61-47.63,.16-1.18,.3-2.26,.44-3.27l-11.32-2.99-2.72-2.45-45.4-8.43s2.72,5.16,.54,10.33c-2.17,5.17-3.81,4.35-13.59,8.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.25,286.82l21.79,3.87s4.84,2.42,5.81,5.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.05,267.32s-3.74,25.84-8.5,36.05c-4.76,10.2-7.63,16.7-6.87,14.13,.75-2.57,15.56-21.27,22.61-47.63l-7.23-2.55Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.23,263.35s-1.14,8.02,2.77,14.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.74,241.33s14.41-2.99,17.13,1.9c2.72,4.89-.82,14.41-.82,15.5s16.58,2.17,18.76,10.33c2.17,8.16-7.88,15.77-12.23,18.76-4.35,2.99,3.53,7.34-5.71,9.79-9.24,2.45-2.45-7.61-2.45-7.61,0,0-8.97,6.25-12.23-3.53s1.63-15.77,1.09-16.58c-.54-.82-12.23-2.17-13.05-6.52s8.7-15.5,9.51-22.02Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M169.39,285.92l35.34-16.58-28.54-11.69s-1.09,4.62-2.17,7.61-12.78,6.52-12.78,6.52c0,0-.27,5.44,8.16,14.14Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.24,192.13s4.59,5.95,12.5,13.86c1.63,1.63,3.26,3.53,3.26,3.53,0,0-2.74,4.47-3.33,13.84-.51,8.11,3.08,13.88,.07,25.31-2.51,9.5-14.41,21.2-18.49,23.92-4.08,2.72-10.6,1.09-14.95-.82-4.35-1.9-12.78-5.58-15.89-8.22-8.42-7.19-15.92-28.48-16.74-33.64-.82-5.17-1.09-11.96-1.09-11.96,0,0,5.71,0,20.93-6.8,15.22-6.8,33.71-19.03,33.71-19.03Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.27,191.69s-7.62,9.42-22.17,18.68c-14.55,9.26-23.81,3.97-23.81,3.97,0,0,11.91,7.5,23.81,3.53,11.91-3.97,27.78-26.46,27.78-26.46l-5.61,.28Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.79,232.7s-.39,1.54-4.43,3.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.09,232.31s1.16,1.16,5.39,2.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.34,212.72s-1.3,16.51-4.78,18.68c-3.48,2.17-10.43-13.03-10.43-13.03l12.6-13.47,2.61,7.82Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.63,212.9s-13.01,8.38-13.72,9.97c-.72,1.59,2.84,.12,5.66-.89,2.83-1.01,11.78-4.42,12.03-6.73,.25-2.31-1.21-3.62-3.97-2.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.8,214.69s-2.45,2.72-.54,3.53,11.42,3.81,13.05,2.99c1.63-.82-4.08-4.08-6.52-5.44-2.45-1.36-3.81-3.26-5.98-1.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.74,247.15s6.52-1.36,5.98-4.35c-.54-2.99-4.08-8.7-4.08-8.7l.27-13.59",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.07,245.61s-1.93,1.54-3.66,1.54-1.93-1.73-1.54-2.89",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.01,254.93s4.89-2.45,7.61-1.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.72,228.83c0,2.03-.79,3.67-1.77,3.67s-1.77-1.64-1.77-3.67,.79-3.67,1.77-3.67,1.77,1.64,1.77,3.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.26,229.37c0,2.03-.79,3.67-1.77,3.67s-1.77-1.64-1.77-3.67,.79-3.67,1.77-3.67,1.77,1.64,1.77,3.67Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M156.07,245.95s5.44-6.52,8.97-6.8c3.53-.27,3.81,1.63,3.81,3.26s-7.88,5.98-9.24,10.33-1.36,6.52-3.26,10.06c-1.9,3.53-5.16,6.52-5.16,6.52,0,0,1.09-18.21,4.89-23.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.34,283.47s6.25-25.28,6.25-26.1,5.44-33.44,5.44-33.44c0,0,13.32-10.6,14.41-11.96,1.09-1.36,2.72-5.16,4.89-3.81,2.17,1.36,1.36,7.34,1.36,7.34,0,0,2.17,1.36,2.17,4.08s-1.09,7.34-2.17,10.33c-1.09,2.99-7.61,16.04-7.61,16.04,0,0-2.45,14.68-3.53,19.3s-5.71,11.96-5.71,11.96l-.82,5.71-14.68,.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.68,215.51s-2.99,6.52-3.53,8.16c-.54,1.63-6.25,5.98-7.07,9.24-.82,3.26-4.08,10.6-4.08,10.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.43,211.97s-1.9,8.43-2.72,9.51c-.82,1.09-6.52,8.43-7.34,10.87-.82,2.45-3.26,7.34-3.26,7.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.08,
    y1: 223.39,
    x2: 148.19,
    y2: 228.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.89,279.93s-3.71,16.55-1.98,18.28c1.73,1.73,28.41,3.46,29.15,3.46s2.72-17.29,1.98-20.26c-.74-2.96-11.86-3.71-16.8-3.71s-11.12-.49-12.35,2.22Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.91,298.21s-2.47,8.4-2.47,13.83-5.44,42.74-8.15,61.27c-2.72,18.53,0,25.69,5.44,30.14,5.43,4.45,13.83,7.41,19.76,6.18,5.93-1.24,13.59-.99,17.79-9.39,4.2-8.4,5.44-24.7,2.96-37.06-2.47-12.35-6.18-61.52-6.18-61.52l-29.15-3.46Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.46,377.8s7.48,1.21,8.9,5.06c1.42,3.84,.2,8.09-4.25,11.73-4.45,3.64-13.75,6.68-14.97,6.68s1.62-14.97,4.05-18.61c2.43-3.64,6.27-4.85,6.27-4.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.69,359.6s-5.22,8.76-4.5,19.59c.83,12.55,4.24,32.83,4.24,32.83,0,0,38.39-6.35,55.34-9.8,16.95-3.44,20.12-3.97,20.12-3.97,0,0,2.12-15.09,6.35-21.71l4.24-6.62s-3.44-18.27-12.18-20.39c-8.74-2.12-73.61,10.06-73.61,10.06Z",
    style: {
      fill: "#d4d4d4",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M240.8,393.99s2.63,4.65,6.27,7.08c3.64,2.43,7.48-.81,7.48-.81l-13.75-6.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.18,386.5s-.81,4.85,.4,6.07c1.21,1.21,11.33,8.7,14.97,7.69s5.06-4.25,4.65-5.66c-.4-1.42-20.03-8.09-20.03-8.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.79,383.67s-1.82,.61-.61,2.83c1.21,2.23,12.74,7.69,16.18,8.09,3.44,.4,5.26-.81,6.27-3.84,1.01-3.03,2.43-4.05,1.21-4.65-1.21-.61-23.06-2.43-23.06-2.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.79,383.67s17.8,3.84,21.64,3.84,5.66-4.05,6.07-6.27c.4-2.23,1.42-3.44-4.05-3.44s-20.03,1.42-22.45,2.02c-2.43,.61-3.84,2.02-1.21,3.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M202.46,391.64s56.66-12.44,73.34-12.71c0,0-12.71-30.45-16.42-33.63-3.71-3.18-53.49,7.34-66.71,10.42-13.02,3.04-13.07,3.42-12.99,3.87,0,0,16.15,12.71,22.77,32.04Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M250.9,359.56l4.53,13.26-3.38,.56c-.61,.1-1.18,.14-1.71,.11-.53-.03-1.02-.14-1.46-.34-.44-.2-.84-.5-1.18-.9-.34-.41-.63-.94-.85-1.61-.18-.54-.26-1.01-.24-1.41,.02-.41,.14-.75,.36-1.02,.22-.27,.54-.48,.95-.63-.57,0-1.09-.11-1.54-.33-.45-.22-.84-.54-1.17-.96-.33-.42-.6-.94-.82-1.58-.22-.63-.33-1.21-.33-1.72,0-.51,.1-.96,.32-1.33,.21-.37,.53-.68,.96-.93,.43-.24,.96-.42,1.61-.52l3.96-.65Zm.16,8.25l-.85,.14c-.5,.08-.86,.22-1.08,.4-.22,.19-.34,.44-.35,.75,0,.31,.07,.69,.22,1.14,.16,.47,.37,.82,.62,1.05,.25,.23,.56,.36,.92,.4,.36,.04,.8,.02,1.31-.07l.49-.08-1.28-3.73Zm-2.1-6.14l-.95,.16c-.76,.12-1.22,.39-1.37,.79-.15,.4-.1,.97,.15,1.71,.18,.53,.4,.96,.64,1.27,.24,.31,.54,.52,.9,.64,.36,.11,.78,.13,1.28,.05l.87-.14-1.53-4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.35,361.12l4.53,13.26-2.48,.41-4.53-13.26,2.48-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.74,361.88l4.53,13.26-2.52,.41-3.96-11.59-3.33,.55-.57-1.67,5.85-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.65,363.04l4.53,13.26-2.52,.41-3.96-11.59-3.33,.55-.57-1.67,5.85-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.03,364.59c.83-.14,1.57-.09,2.23,.13,.66,.22,1.24,.61,1.73,1.16,.49,.55,.9,1.26,1.23,2.13l-2.02,.76c-.2-.51-.42-.95-.66-1.33-.24-.38-.51-.65-.8-.83-.29-.18-.62-.24-.99-.18-.41,.07-.66,.23-.75,.49-.09,.26-.07,.57,.05,.93,.2,.58,.5,1.03,.9,1.36,.4,.33,.89,.64,1.47,.93l2.24,1.19c.63,.32,1.17,.71,1.63,1.16,.46,.45,.81,1.04,1.06,1.77,.36,1.05,.32,1.91-.12,2.58-.44,.67-1.21,1.1-2.31,1.28-.65,.11-1.22,.1-1.71-.02-.5-.12-.93-.33-1.3-.62-.37-.3-.69-.65-.96-1.06-.27-.41-.51-.85-.71-1.33l2.02-.71c.16,.41,.34,.77,.53,1.09,.19,.31,.4,.55,.65,.71,.25,.15,.56,.2,.92,.14,.37-.06,.62-.23,.74-.49,.12-.27,.12-.58,0-.92-.15-.45-.38-.8-.67-1.06-.29-.26-.67-.51-1.14-.76l-2.22-1.18c-.72-.37-1.39-.82-2.01-1.37-.61-.55-1.07-1.26-1.37-2.14-.22-.63-.26-1.22-.14-1.76,.12-.54,.39-.99,.81-1.35,.42-.36,.98-.6,1.67-.71Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 199,
    y1: 364.64,
    x2: 258.82,
    y2: 353.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.41,
    y1: 348.29,
    x2: 252.38,
    y2: 355.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.98,
    y1: 351.27,
    x2: 232.44,
    y2: 358.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.34,
    y1: 356.84,
    x2: 205.31,
    y2: 361.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.95,
    y1: 360.49,
    x2: 255.77,
    y2: 349.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Piggy_Bank--inject-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M390.52,331.77s13.34-8.31,16.84-6.56,0,14.65-.87,17.72l-.87,3.06-15.09-14.22Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.74,339.21s8.09-14.22,9.84-11.81c1.75,2.41-1.09,10.28-1.09,10.28",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "342.4 392.79 359.46 417.29 368.21 417.29 374.99 399.14",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "374.33 405.92 380.24 417.29 388.99 417.29 395.77 399.14",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "328.84 392.79 345.9 417.29 354.65 417.29 361.43 399.14",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.77,354.33c-1.66,4-5.58,6.18-8.76,4.86-3.18-1.32-4.41-5.63-2.75-9.63,1.66-4,5.58-6.18,8.76-4.86s4.41,5.63,2.75,9.63Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 366.27,
    cy: 367.05,
    rx: 42.49,
    ry: 47.02,
    transform: "translate(-8.86 725.04) rotate(-88.72)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M355.09,341.61s7.22-19.25,11.59-21.22c4.37-1.97,8.53,8.53,9.84,14,1.31,5.47,.44,7.22,.44,7.22",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.68,320.4s-4.59,10.94-5.03,16.4-1.31,10.72,3.94,9.62c5.25-1.09,10.28-2.62,9.4-10.28",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 393.28,
    cy: 377.26,
    rx: 14.65,
    ry: 13.78,
    transform: "translate(-48.27 57.84) rotate(-7.93)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 397.3,
    cy: 377.26,
    rx: 14.65,
    ry: 13.78,
    transform: "translate(-48.23 58.4) rotate(-7.93)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.61,377.81c0,2.6-1.03,4.7-2.3,4.7s-2.3-2.11-2.3-4.7,1.03-4.7,2.3-4.7,2.3,2.11,2.3,4.7Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.36,376.83c0,2.6-1.03,4.7-2.3,4.7s-2.3-2.11-2.3-4.7,1.03-4.7,2.3-4.7,2.3,2.11,2.3,4.7Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.21,358.14c.38,1.9-.04,3.58-.93,3.75-.89,.18-1.91-1.22-2.29-3.11-.38-1.9,.04-3.58,.93-3.75,.89-.18,1.91,1.22,2.29,3.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.14,356.39c.38,1.9-.04,3.58-.93,3.75-.89,.18-1.91-1.22-2.29-3.11-.38-1.9,.04-3.58,.93-3.75,.89-.18,1.91,1.22,2.29,3.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.43,
    y1: 351.02,
    x2: 384.18,
    y2: 345.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.55,
    y1: 344.9,
    x2: 394.67,
    y2: 351.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "360.34 405.92 366.24 417.29 374.99 417.29 378.93 406.79",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bills--inject-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "292.24 407.37 238.57 427.55 315.82 453.39 365.35 423.54 292.24 407.37",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "292.92 418.71 304.88 413.04 354.91 424.6 315.48 446.85 291.56 440.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.46,
    y1: 415.56,
    x2: 346.85,
    y2: 427.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.36,
    y1: 422.7,
    x2: 306.68,
    y2: 444.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "241.98 407.62 181.88 423.31 252.35 454.09 317.1 426.8 241.98 407.62",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M230.9,428.01l-18-8.43,2.36-.76c.43-.14,.89-.23,1.38-.27,.49-.04,1.04-.02,1.63,.06,.6,.08,1.26,.24,1.99,.48,.73,.23,1.54,.56,2.45,.99,.73,.34,1.3,.65,1.71,.93,.41,.28,.67,.52,.77,.73,.1,.21,.05,.39-.16,.53,.5-.07,1.06-.05,1.69,.04,.63,.1,1.3,.27,2.03,.51,.73,.24,1.52,.57,2.38,.97,.86,.4,1.56,.78,2.11,1.12,.55,.35,.92,.66,1.14,.93,.21,.28,.26,.52,.15,.73-.11,.21-.39,.39-.84,.54l-2.76,.89Zm-8.89-5.55l.59-.19c.35-.11,.52-.24,.52-.4,0-.15-.17-.33-.49-.54-.32-.21-.79-.46-1.4-.74-.64-.3-1.19-.51-1.65-.64-.46-.13-.87-.18-1.23-.17-.36,.02-.71,.08-1.07,.19l-.34,.11,5.07,2.37Zm8.33,3.9l.66-.21c.53-.17,.65-.4,.36-.69-.29-.29-.94-.67-1.95-1.14-.73-.34-1.36-.6-1.9-.78-.54-.18-1.03-.29-1.46-.33-.43-.04-.82,0-1.17,.11l-.6,.19,6.07,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.54,425.86l-18-8.43,1.73-.56,18,8.43-1.73,.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.75,424.83l-18-8.43,1.75-.57,15.74,7.37,2.32-.75,2.27,1.06-4.07,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.69,423.23l-18-8.43,1.75-.57,15.74,7.37,2.32-.75,2.27,1.06-4.07,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.29,420.97c-.58,.19-1.27,.24-2.08,.17-.81-.07-1.72-.27-2.73-.59-1.01-.32-2.12-.75-3.33-1.3l.95-.75c.71,.32,1.37,.59,1.98,.82,.61,.23,1.13,.38,1.58,.47,.44,.09,.79,.09,1.04,0,.28-.09,.33-.23,.13-.42-.2-.19-.55-.4-1.03-.62-.79-.37-1.52-.64-2.22-.81-.69-.17-1.45-.33-2.27-.46l-3.21-.55c-.89-.15-1.77-.35-2.64-.6s-1.81-.61-2.8-1.07c-1.42-.67-2.3-1.25-2.63-1.75-.33-.5-.11-.88,.66-1.13,.45-.15,.96-.21,1.51-.18,.56,.02,1.16,.12,1.79,.27,.64,.16,1.29,.36,1.96,.61,.67,.25,1.35,.52,2.02,.82l-1,.71c-.58-.26-1.12-.48-1.61-.68-.5-.19-.93-.32-1.32-.4-.38-.08-.7-.07-.95,0-.26,.08-.3,.22-.12,.42,.18,.19,.51,.4,.98,.62,.61,.28,1.17,.5,1.7,.64,.53,.14,1.12,.27,1.79,.38l3.17,.54c1.02,.16,2.08,.4,3.2,.7,1.12,.3,2.27,.73,3.45,1.28,.86,.4,1.52,.79,1.99,1.17,.47,.38,.71,.71,.73,1.01,.02,.29-.21,.52-.69,.67Z"
  }))), /*#__PURE__*/React.createElement("polyline", {
    points: "271.11 419.87 225.93 436.04 252.32 447.37 300.13 428.01",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.16,
    y1: 433.6,
    x2: 259.47,
    y2: 444.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.83,
    y1: 431.24,
    x2: 266.67,
    y2: 441.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.13,
    y1: 438.99,
    x2: 277.03,
    y2: 422.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.88,
    y1: 419.86,
    x2: 297.43,
    y2: 426.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.69,
    y1: 422.19,
    x2: 294.37,
    y2: 430.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "216.17 421.73 148.86 421.73 159.6 449.49 216.17 421.73",
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "155.75 424.04 191.66 424.04 153.94 436.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.96 449.49 38.77 441.97 23.51 349.58 144.71 355.21 159.96 449.49",
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.96 449.49 38.77 441.97 23.51 349.58 144.71 355.21 159.96 449.49",
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.11 449.49 34.91 441.97 19.66 349.58 140.85 355.21 156.11 449.49",
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.44 437.87 35.16 441.97 159.96 449.49 159.24 445.39 34.44 437.87",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.17 425.34 159.6 449.49 159.6 445.89 216.17 421.73 216.17 425.34",
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress);
export default __webpack_public_path__ + "static/media/stress.da11a1bd7d4aa8798b22427500a98500.svg";
export { ForwardRef as ReactComponent };